const avatarTableActions = {
  photo: 'PHOTO'
};

export default avatarTableActions;
